import { useQuery } from "@tanstack/react-query";
import { getHero } from "../api/endpoints";
import { qk } from "../api/queryKeys";

export default function useHero() {
  return useQuery({
    queryKey: qk.hero,
    queryFn: ({ signal }) => getHero({ signal }),
    staleTime: 10 * 60 * 1000,
  });
}
